// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__vCE6x","card":"style_card__3SyyE","backTitleCon":"style_backTitleCon__38z7Z","cardTitle":"style_cardTitle__33RJ3"};